export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAILS = "PRODUCT_LIST_FAILS";

export const PRODUCT_ALL_LIST_REQUEST = "PRODUCT_ALL_LIST_REQUEST";
export const PRODUCT_ALL_LIST_SUCCESS = "PRODUCT_ALL_LIST_SUCCESS";
export const PRODUCT_ALL_LIST_FAILS = "PRODUCT_ALL_LIST_FAILS";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAILS = "PRODUCT_DETAILS_FAILS";

export const PRODUCT_CREATE_REVIEW_REQUEST = "PRODUCT_CREATE_REVIEW_REQUEST";
export const PRODUCT_CREATE_REVIEW_SUCCESS = "PRODUCT_CREATE_REVIEW_SUCCESS";
export const PRODUCT_CREATE_REVIEW_FAILS = "PRODUCT_CREATE_REVIEW_FAILS";
export const PRODUCT_CREATE_REVIEW_RESET = "PRODUCT_CREATE_REVIEW_RESET";

export const PRODUCT_TOP_REQUEST = "PRODUCT_TOP_REQUEST";
export const PRODUCT_TOP_SUCCESS = "PRODUCT_TOP_SUCCESS";
export const PRODUCT_TOP_FAILS = "PRODUCT_TOP_FAILS";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAILS = "PRODUCT_DELETE_FAILS";
export const PRODUCT_DELETE_RESET = "PRODUCT_DELETE_RESET";

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAILS = "PRODUCT_UPDATE_FAILS";
export const PRODUCT_UPDATE_RESET = "PRODUCT_UPDATE_RESET";

export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST";
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS";
export const PRODUCT_CREATE_FAILS = "PRODUCT_CREATE_FAILS";
export const PRODUCT_CREATE_RESET = "PRODUCT_CREATE_RESET";

export const PRODUCT_IMAGE_UPDATE_REQUEST = "PRODUCT_IMAGE_UPDATE_REQUEST";
export const PRODUCT_IMAGE_UPDATE_SUCCESS = "PRODUCT_IMAGE_UPDATE_SUCCESS";
export const PRODUCT_IMAGE_UPDATE_FAILS = "PRODUCT_IMAGE_UPDATE_FAILS";
export const PRODUCT_IMAGE_UPDATE_RESET = "PRODUCT_IMAGE_UPDATE_RESET";
